import createSafeContext from"../../../utils/createSafeContext";export const[usePointsSummaryView,ViewProvider]=createSafeContext('PointsSummaryView');